// extracted by mini-css-extract-plugin
export default {"alertCard":"AlertCard_alertCard__V9TAN","alertActions":"AlertCard_alertActions__kZddT","date":"AlertCard_date__98T0A","alertIcons":"AlertCard_alertIcons__SIGWq"};